module.exports = __webpack_public_path__ + "img/ears_male_mask.87b4b850.png";